<template>
    <c-modal @close="close" :title="title">
        <template v-if="language">
            <div class="margin-b-32" v-for="assigned in selected">
                <div class="row">
                    <div class="columns fs-large fw-medium">{{assigned.opdrachtnemer.user.name}}</div>
                    <div class="columns shrink" v-if="!assigned.afgewezen_at && !assigned.klaar_at && !assigned.ingetrokken_at && !assigned.is_verlopen">
                        <button type="button" class="c-btn c-btn--alert c-btn--hollow c-btn--minuscule no-margin" @click.prevent="withdrawTranslator(assigned)">Annuleren</button>
                    </div>
                    <div class="columns shrink">
                        <c-status-label :label="true" :target="assigned" :assignment="true"></c-status-label>
                    </div>
                </div>
                <c-accordion :linktext="'Opmerking en instructies tonen'">
                    <p class="fw-medium margin-t-8 margin-b-4">Opmerking en instructies</p>
                    <div class="color-dark-gray fs-small">
                        <p>{{assigned.instructies || '-'}}</p>
                    </div>
                </c-accordion>
            </div>

            <h2 v-if="selected.length" class="margin-t-48">Extra {{type | lower }} toevoegen</h2>

            <c-form ref="form" @valid="submit" :autocomplete="'off'">

                <c-form-element
                    :label="'Reactietijd'"
                    :horizontal="true">
                    <c-day-timepicker :number-of-day="17" :name="'response-time'" :required="true"  v-model="respons_tijd"></c-day-timepicker>
                </c-form-element>

                <c-form-element
                    :label="'Vertaaldeadline'"
                    :horizontal="true"
                    v-if="this.request.is_tolk_opdracht==0"
                >
                    <c-datepicker :required="true" v-model="deadline_datum" name="deadline-date"></c-datepicker>
                    <c-timepicker class="margin-t-16" :name="'deadline-time'" :required="true"  v-model="deadline_tijd"></c-timepicker>
                </c-form-element>

                <c-form-element
                    :label="'Een spoedgeval?'"
                    :helptext="'In geval van spoed kan je tot max. 5 personen selecteren'"
                    :horizontal="true">
                    <c-radio :required="true" :name="'emergency'" v-model="is_spoed" :options="[
                        {label:'Ja', value:'1'},
                        {label:'Nee', value:'0'}
                        ]"></c-radio>
                </c-form-element>

                <c-selector
                    v-model="selectie"
                    ref="selector"
                    :translators="translators"
                    :max="(is_spoed == '1') ? 5 : 1"
                    :type="type">
                </c-selector>

                <template v-for="id in selectie">
                    <h2 class="margin-t-40 margin-b-8">{{getName(id)}}</h2>
                    <c-form-element
                        :label="'Opmerking en instructies'">
                        <c-textarea v-model="instructies[id]" :name="'remark'"></c-textarea>
                    </c-form-element>
                </template>

                <div class="c-modal__btn">
                    <input type="submit" class="c-btn c-btn--secondary no-margin" :disabled="selectie.length == 0" :value="type + ' koppelen'"/>
                </div>

            </c-form>
        </template>
    </c-modal>
</template>
<script>
import CModal from '@components/Modal';
import CAccordion from '@components/Accordion';
import CStatusLabel from '@components/StatusLabel';
import CSelector from '@components/form/translators/Selector';
import Form from '@mixins/Form';

export default {
    components: { CModal, CSelector, CAccordion, CStatusLabel },
    mixins: [ Form ],
    props: {
        request: {
            type: Object
        },
        language: {
            type: Object
        },
        reviser: {
            type: Boolean
        }
    },
    data() {
        return {
            respons_tijd: '',
            deadline_datum: '',
            deadline_tijd: '',
            is_spoed: '0',
            instructies: {},
            selectie: [],
            translators: []
        }
    },
    computed: {
        title() {
            return (this.language) ? this.type + ' - ' + this.language.doeltaal.taal : '-';
        },
        type() {
            if ( this.reviser ) {
                return 'Reviseuren';
            }
            else {
                return ( this.request.is_tolk_opdracht == 1 ) ? 'Tolken' : 'Vertalers';
            }
        },
        selected() {
            let filter;
            if (this.request.is_tolk_opdracht == 1) {
                filter = item => item.moet_reviseren == 0 && item.moet_vertalen == 0;
            } else if (this.reviser) {
                filter = item => item.moet_reviseren == 1;
            } else {
                filter = item => item.moet_vertalen == 1;
            }
            let key = ( this.reviser ) ? 'moet_reviseren' : 'moet_vertalen';
            return this.language.opdrachtnemers.filter(filter);
        }
    },
    methods: {
        submit() {
            let params = {
                ...this._data,
                moet_reviseren: this.reviser ? 1 : 0
            };

            delete params.translators;

            this.$xhr.put('/api/request-detail/' + this.$route.params.id + '/vertalingen/' + this.language.id + '/assign/', params).then( ({result}) => {
                this.$store.dispatch('request/addTranslators', {language: this.language, translators: result});
                this.$store.dispatch('toasts/success', {title: this.type + ' koppelen', text: 'De geselecteerde ' + this.type.toLowerCase() + ' zijn gekoppeld aan de aanvraag.'});
                this.close();
            }).catch( (e) => {
                this.$store.dispatch('toasts/alert', {title: this.type + ' koppelen', text: 'Er is helaas iets fout gegaan bij het koppelen.'});
            })
        },
        close() {
            this.respons_tijd = '';
            this.deadline_datum = '';
            this.deadline_tijd = '';
            this.is_spoed = 0;
            this.instructies = {};
            this.selectie = [];

            this.$refs.selector.clear();
            this.$refs.form.reinitialize();

            this.$emit('close');
        },
        getName(id) {
            let found = this.translators.find( t => t.opdrachtnemer_id == id );
            return ( found ) ? found.opdrachtnemer.user.name : '';
        },

        load() {
            this.translators = [];

            this.$xhr.get('/api/translators/', {
                id: this.$route.params.id,
                taal: this.language.id,
                reviseren: this.reviser ? 1 : 0
            }).then( ({result}) => {
                this.translators = result;
            }).catch( () => {
                this.$store.dispatch('toasts/alert', {title: this.type + ' zoeken', text: 'Helaas konden we geen ' + this.type.toLowerCase() + ' vinden.'});
            });
        },

        withdrawTranslator(translator) {

            const confirm = translator => {
                this.$xhr.post('/api/request-detail/' + this.$route.params.id + '/withdraw/' + translator.id + '/').then(({result}) => {
                    this.$store.dispatch('request/changeAssignment');
                    this.$store.dispatch('toasts/success', {title: 'Toewijzing annuleren', text: 'Je hebt de toewijzing geannuleerd'});
                    translator.afgewezen_at = (new Date()).toJSON();
                    translator.geaccepteerd_at = null;
                }).catch(e =>
                    this.$store.dispatch('toasts/alert', {title: 'Toewijzing annuleren', text: 'Helaas konden we de toewijzing niet annuleren'})
                );
            };
            this.$store.dispatch('confirm/open', {
                text: 'De toewijzing van deze tolk/vertaler wordt geannuleerd',
                buttons: [
                    { text: 'Ja, toewijzing annuleren', action: (e) => { this.$store.dispatch('confirm/close'); confirm(translator); }},
                    { text: 'Nee, toewijzing behouden', action: (e) => { this.$store.dispatch('confirm/close'); }}
                ]
            });

        }
    }
}
</script>
